import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface SnackbarMessage {
  message: string
  type?: 'success' | 'error' | 'warning' | 'info'
  timeout?: number
}

export const useSnackbarStore = defineStore('snackbar', () => {
  const isVisible = ref(false)
  const message = ref('')
  const type = ref('info')
  const timeout = ref(1000)
  let timeoutId: number | null = null

  const hide = () => {
    isVisible.value = false
    if (timeoutId) {
      window.clearTimeout(timeoutId)
      timeoutId = null
    }
  }

  const show = (options: SnackbarMessage) => {
    // Clear any existing timeout
    if (timeoutId) {
      window.clearTimeout(timeoutId)
    }

    message.value = options.message
    type.value = options.type || 'info'
    timeout.value = options.timeout || 2000
    isVisible.value = true

    // Set new timeout
    timeoutId = window.setTimeout(() => {
      hide()
    }, timeout.value)
  }

  const showError = (message: string, timeout?: number) => {
    show({
      message,
      type: 'error',
      timeout: timeout || 2000
    })
  }

  const showSuccess = (message: string, timeout?: number) => {
    show({
      message,
      type: 'success',
      timeout: timeout || 1000
    })
  }

  return {
    isVisible,
    message,
    type,
    timeout,
    show,
    hide,
    showError,
    showSuccess
  }
}) 